module.exports = __webpack_public_path__ + "img/5.d1a61f87.jpg";